import { RouteConfig } from 'vue-router'
import ContactView from '../views/ContactView.vue'
import ListView from '../views/ListView.vue'
import AddView from '../views/AddView.vue'
import EditView from '../views/EditView.vue'
const Contact = () => import(/* webpackChunkName: "contact" */ '@contact/Index.vue')
const ContactMaster = () => import(/* webpackChunkName: "contact" */ '@contact/views/Master.vue')

const routes: RouteConfig[] = [
  {
    path: '/contact',
    component: Contact,
    children: [
      {
        path: '',
        component: ContactMaster,
        children: [
          {
            path: 'list',
            name: 'contact-list',
            component: ListView,
          },
          {
            path: 'add',
            name: 'contact-add',
            component: AddView,
          },
          {
            path: 'view',
            name: 'contact-view',
            component: ContactView,
          },
          {
            path: 'edit',
            name: 'contact-edit',
            component: EditView,
          },
        ],
      },
      {
        path:'',
        redirect: 'list'
      }
    ],
  },
]
export default routes
